"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMail = void 0;
var React = __importStar(require("react"));
var IconMail = function (props) { return (React.createElement("svg", __assign({ width: "34px", height: "34px", viewBox: "0 0 34 34" }, props),
    React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "Other-app-mail" },
            React.createElement("g", null,
                React.createElement("rect", { id: "Background", fill: "#4C4C4C", x: 0, y: 0, width: 34, height: 34, rx: 4 }),
                React.createElement("path", { d: "M27.1538462,26 L6.84615385,26 C5.82707692,26 5,25.1936 5,24.2 L5,9.8 C5,8.8064 5.82707692,8 6.84615385,8 L27.1538462,8 C28.1729231,8 29,8.8064 29,9.8 L29,24.2 C29,25.1936 28.1729231,26 27.1538462,26 Z", id: "Path", fill: "#D1D1D1", fillRule: "nonzero" }),
                React.createElement("path", { d: "M27.1538462,26 L6.84615385,26 C5.81046154,26 5,25.1951667 5,24.1666667 C5,23.8751667 5.14030769,23.6001667 5.37661538,23.4278333 L16.4535385,15.1778333 C16.616,15.0586667 16.808,15 17,15 C17.192,15 17.384,15.0586667 17.5464615,15.1778333 L28.6233846,23.4278333 C28.8596923,23.6001667 29,23.8751667 29,24.1666667 C29,25.1951667 28.1895385,26 27.1538462,26 Z", id: "Path", fill: "#E2E2E2", fillRule: "nonzero" }),
                React.createElement("path", { d: "M27.1538462,8 L6.84615385,8 C5.81046154,8 5,8.80483333 5,9.83333333 C5,10.1248333 5.14030769,10.3998333 5.37661538,10.5721667 L16.4535385,18.8221667 C16.616,18.9413333 16.808,19 17,19 C17.192,19 17.384,18.9413333 17.5464615,18.8221667 L28.6233846,10.5721667 C28.8596923,10.3998333 29,10.1248333 29,9.83333333 C29,8.80483333 28.1895385,8 27.1538462,8 Z", id: "Path", fill: "#F7F7F7", fillRule: "nonzero" })))))); };
exports.IconMail = IconMail;
exports.IconMail.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconMail;
